import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackendAPI from "../Common/BackendAPI";
import { useSettings } from "../../App";

function Login() {
  const SettingData = useSettings();
  const navigate = useNavigate();

  const [registerInput, setRegisterInput] = useState([]);
  if (localStorage.getItem("auth_token")) {
    navigate("/");
  }
  const [loginInput, setLogin] = useState({
    error_list: [],
  });

  const [EmailErr, setEmailErr] = useState(null);
  const [PassErr, setPassErr] = useState(null);
  const [SubButtonVal, setSubButtonVal] = useState(null);
  const [ErrorMsg, setErrorMsg] = useState(null);
  const [SuccessMsg, setSuccessMsg] = useState(null);

  const handleInput = (e) => {
    e.persist();
    setRegisterInput({ ...registerInput, [e.target.name]: e.target.value });
  };
  const loginSubmit = (e) => {
    e.preventDefault();
    setEmailErr(null);
    setPassErr(null);
    setErrorMsg(null);
    let errorClient = false;
    setSubButtonVal(1);
    if (registerInput.email === undefined || registerInput.email === "") {
      setEmailErr("The email field is required");
      errorClient = true;
      // return false
    }

    if (registerInput.password === undefined || registerInput.password === "") {
      setPassErr("The password field is required");
      errorClient = true;
      // return false
    }

    if (errorClient) {
      setSubButtonVal(null);
      return false;
    }
    let backendAPILInk = process.env.REACT_APP_LARAVEL_URL;
    if (SettingData?.BACKEND_URL) {
      backendAPILInk = SettingData?.BACKEND_URL;
    }
    const login_url = backendAPILInk + "login";

    const BackendAPIArray = {
      email: registerInput.email,
      password: registerInput.password,
    };
    const up_config = BackendAPI.backEndAPI(BackendAPIArray, "POST");
    fetch(login_url, up_config)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.access_token) {
          setSuccessMsg("Successfully Logged In");
          window.localStorage.setItem("laravel-token", data.access_token);
          window.localStorage.setItem("user-type", data.type);
          window.localStorage.setItem("sort-name", data.sort);
          window.localStorage.setItem("user-permissions", data.permission);
          setSubButtonVal(null);
          let lastActiveUrl = window.localStorage.getItem("last-active-page");

          if (!lastActiveUrl) {
            lastActiveUrl = "/campaign_listing";
          }

          setTimeout(function () {
            window.location.href = ".." + lastActiveUrl;
          }, 2000);
        }
        if (data.message) {
          setSubButtonVal(null);
          setErrorMsg(data.message);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-7">
            <div className="login-layout">
              <img
                src="/assets/images/logo.svg"
                alt="Native Metrics"
                className="brand"
              />
              <div className="login-card">
                <h1>Login</h1>
                <form onSubmit={loginSubmit}>
                  <div className="form-group">
                    <label className="control-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleInput}
                      className="form-control"
                      placeholder="ex. john.doe@example.com"
                    />
                    {EmailErr && <span className="form-error">{EmailErr}</span>}
                  </div>
                  <div className="form-group">
                    <label className="control-label">Password</label>
                    <input
                      type="password"
                      name="password"
                      placeholder="Enter your password"
                      onChange={handleInput}
                      className="form-control"
                    />
                    {PassErr && <span className="form-error">{PassErr}</span>}
                  </div>
                  <div class="form-group">
                    <div className="row gy-3 justify-content-md-between justify-content-center">
                      <div className="col-md-auto order-md-1">
                        <a href="#" className="primary-link">
                          Forgot Password
                        </a>
                      </div>
                      <div className="col-md-auto">
                        <div class="form-check">
                          <input
                            id="inputCheckBox"
                            class="form-check-input"
                            type="checkbox"
                            name="create_fb_campaign"
                          />
                          <label class="form-check-label" for="inputCheckBox">
                            Remember Me
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={SubButtonVal}
                  >
                    <span>Login</span>
                    {SubButtonVal !== null && (
                      <div class="spinner-border text-light" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>

                  {ErrorMsg !== null && (
                    <div class="alert alert-danger mt-4 mb-0" role="alert">
                      {ErrorMsg}
                    </div>
                  )}

                  {SuccessMsg !== null && (
                    <div class="alert alert-success mt-4 mb-0" role="alert">
                      {SuccessMsg}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
